import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-cabecalho',
  templateUrl: './cabecalho.component.html',
  styleUrls: ['./cabecalho.component.scss']
})

export class CabecalhoComponent implements OnInit {
  @Input() data;
  bgImage: string;

  constructor() {
  }

  ngOnInit() {
    this.bgImage = this.data.IMAGEM.URL;
  }

}
